module.exports = __webpack_public_path__ + "static/media/logo2.a5e740ae.png";